import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {User} from '../models/user';
import {Habilitation} from '../models/admin/habilitation';
import {Role} from '../models/admin/role';
import {BASE_URL, URL_BACK_TO_GESCOM} from '../app.constants';
import {Site} from "../models/admin/site";

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const ID_USER_CONNECTED = 'id-user-connected';
const HABILITATION = 'auth-habilitation';
const SITES = 'auth-sites';
const USERNAME = 'auth-username';
const USER_TO_MANIPULATE = 'auth-user';
const HAB_TO_MANIPULATE = 'current-habilitations';
const USERS = 'user-for-current-site';
const CURRENT_SITE = 'current-site';
const CURRENT_HABILITATION = 'current-habilitation';
const ACTION_KEY = 'action-user';
const SITE_TO_MANIPULATE = 'current-sites';
const LANGUE = 'langue';
const MODE = 'mode';
const CODE_SITE = 'code_site';
const TENANT_ID = 'X-TenantID';
const LICENSE = 'license';
const JOUR_MAX_NOTIF_LICENCE = 'jour_max_notif_licence';
const HOSPITALISATION_GESCOM = 'hospi-gescom';
const NOMBRE_UTILISATEUR = 'nombre-utilisateur';
const ACTIVER_UTILISATION_ROLE_ADMIN_SOCIETE = 'activer_utilisation_role_admin_societe';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  public authUrl = BASE_URL + '/auth';
  constructor(private http: HttpClient, private router: Router) { }
  /**
   * Deconnecter l'utilisateur
   */
  clearLocalStorage() {
    window.localStorage.clear();
    window.sessionStorage.clear();
    this.router.navigate(['/signin']).then(
      () => {
        window.location.reload();
      }
    );
  }
  /**
   * Deconnecter l'utilisateur
   */
  signOut(): void {
    this.http.get(`${this.authUrl}/users/log-out`).subscribe((result: any) => {
      this.clearLocalStorage();
    }, error => {
      this.clearLocalStorage()
    });

    window.localStorage.clear();
    window.sessionStorage.clear();
    // this.router.navigate(['/signin']).then(
    //   () => {
    //     window.location.reload();
    //   }
    // );
    // window.location.href = URL_BACK_TO_GESCOM;

  }

  public saveJourMaxDeNotificationLicence(data: any): void {
    window.localStorage.removeItem(JOUR_MAX_NOTIF_LICENCE);
    window.localStorage.setItem(JOUR_MAX_NOTIF_LICENCE, JSON.stringify(data));
  }

  public getJourMaxDeNotificationLicence(): any {
    const data = window.localStorage.getItem(JOUR_MAX_NOTIF_LICENCE);
    return JSON.parse(data);
  }

  public saveLicense(data: any): void {
    window.localStorage.removeItem(LICENSE);
    window.localStorage.setItem(LICENSE, JSON.stringify(data));
  }

  public getLicense(): any {
    const data = window.localStorage.getItem(LICENSE);
    return JSON.parse(data);
  }

  public saveNbrUser(data: any): void {
    window.localStorage.removeItem(NOMBRE_UTILISATEUR);
    window.localStorage.setItem(NOMBRE_UTILISATEUR, JSON.stringify(data));
  }

  public getNbrUser(): any {
    const data = window.localStorage.getItem(NOMBRE_UTILISATEUR);
    return JSON.parse(data);
  }
  /**
   * Sauvegarder mon token
   */
  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }
  /**
   * Recuperer mon token lorsque je suis connecte
   */
  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  public saveLangue(token: string): void {
    window.localStorage.removeItem(LANGUE);
    window.localStorage.setItem(LANGUE, token);
  }

  /**
   * Recuperer mon langue lorsque je suis connecte
   */
  public getLangue(): string {
    return localStorage.getItem(LANGUE);
  }
  /**
   * Mettre un utilisateur en session
   */
  public saveUser(user): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
  public saveIdUserConnected(idUser): void {
    window.localStorage.removeItem(ID_USER_CONNECTED);
    window.localStorage.setItem(ID_USER_CONNECTED, JSON.stringify(idUser));
  }
  public getIdUserConnected(): any {
    return JSON.parse(localStorage.getItem(ID_USER_CONNECTED));
  }

  /**
   * Mettre un utilisateur en session
   */
  public saveUsername(username): void {
    window.localStorage.removeItem(USERNAME);
    window.localStorage.setItem(USERNAME, JSON.stringify(username));
  }


  /**
   * Mettre les habilitations d'un utilisateur en session
   */
  public saveHabilitations(habilitations: any): void {
    window.localStorage.removeItem(HABILITATION);
    window.localStorage.setItem(HABILITATION, JSON.stringify(habilitations));
  }

  /**
   * Recuperer l'utilisateur en session
   */
  public getUser(): any {
    return JSON.parse(localStorage.getItem(USER_KEY));
  }

  /**
   * Recuperer l'utilisateur en session
   */
  public getUsername(): any {
    return JSON.parse(localStorage.getItem(USERNAME));
  }


  /**
   * recuperer l'ensemble des sites habilitations il est affecte
   */
  public getHabilitations(): any {
    return JSON.parse(localStorage.getItem(HABILITATION));
  }


  public saveUserToManipulate(user: User): void {
    window.localStorage.removeItem(USER_TO_MANIPULATE);
    window.localStorage.setItem(USER_TO_MANIPULATE, JSON.stringify(user));
  }

  public getUserToManipulate(): void {
    return JSON.parse(localStorage.getItem(USER_TO_MANIPULATE));
  }

  public saveHabilitationToManipulate(habilitations: Habilitation[]): void {
    window.localStorage.removeItem(HAB_TO_MANIPULATE);
    window.localStorage.setItem(HAB_TO_MANIPULATE, JSON.stringify(habilitations));
  }

  public getHabilitationToManipulate(): void {
    return JSON.parse(localStorage.getItem(HAB_TO_MANIPULATE));
  }

  public saveCurrentUsers(user: User[]): void {
    window.localStorage.removeItem(USERS);
    window.localStorage.setItem(USERS, JSON.stringify(user));
  }

  public getCurrentUsers(): void {
    return JSON.parse(localStorage.getItem(USERS));
  }

  /**
   * Sauvegarder ma variable globale qui dit si le systeme est configuré pour l'hospitalisation ou pour la gescom
   */
  public saveHospitalisationGescom(hospiOuGoscom: string): void {
    window.localStorage.removeItem(HOSPITALISATION_GESCOM);
    window.localStorage.setItem(HOSPITALISATION_GESCOM, JSON.stringify(hospiOuGoscom));
  }

  /**
   * Recuperer mon token lorsque je suis connecte
   */
  public getHospitalisationGescom(): string {
    return JSON.parse(localStorage.getItem(HOSPITALISATION_GESCOM));
  }
  /**
   * Mettre les sites en session
   */
  public saveSites(sites): void {
    window.localStorage.removeItem(SITES);
    window.localStorage.setItem(SITES, JSON.stringify(sites));
  }
  /**
   * recuperer l'ensemble des sites auxquelles il est affecte
   */
  public getSites(): any {
    return JSON.parse(localStorage.getItem(SITES));
  }
  public saveSiteToManipulate(sites: Site[]): void {
    window.localStorage.removeItem(SITE_TO_MANIPULATE);
    window.localStorage.setItem(SITE_TO_MANIPULATE, JSON.stringify(sites));
  }

  public getSiteToManipulate(): any {
    return JSON.parse(localStorage.getItem(SITE_TO_MANIPULATE));
  }

  public saveCurrentSite(site: number): void {
    window.localStorage.removeItem(CURRENT_SITE);
    window.localStorage.setItem(CURRENT_SITE, JSON.stringify(site));
  }

  public getCurrentSite(): any {
    return JSON.parse(localStorage.getItem(CURRENT_SITE));
  }

  public saveTenantID(tenantId: string): void {
    window.localStorage.removeItem(TENANT_ID);
    window.localStorage.setItem(TENANT_ID, tenantId);
  }
  public getTenantID(): any {
    return localStorage.getItem(TENANT_ID);
  }

  public saveCurrentMenu(content, name): void {
    window.localStorage.removeItem(name);
    window.localStorage.setItem(name, JSON.stringify(content));
  }

  public deleteCurrentMenu(name): void {
    window.localStorage.removeItem(name);
  }

  public getCurrentMenu(name): any {
    return JSON.parse(localStorage.getItem(name));
  }


  public saveHabilitation(id: string): void {
    window.localStorage.removeItem(CURRENT_HABILITATION);
    window.localStorage.setItem(CURRENT_HABILITATION, id);
  }

  /**
   * Recuperer mon Habilitation lorsque je suis connecte
   */
  public getHabilitation(): string {
    return localStorage.getItem(CURRENT_HABILITATION);
  }
  public getIpAddress(): any {
    // https://cors-anywhere.herokuapp.com/http://api.ipify.org/?format=json
    return this.http.get(`http://api.ipify.org/?format=json`).toPromise();
  }
  public saveActions(actions: any): void {
    window.localStorage.removeItem(ACTION_KEY);
    window.localStorage.setItem(ACTION_KEY, JSON.stringify(actions));
  }

  public getActions(): any {
    const actions = window.localStorage.getItem(ACTION_KEY);
    return JSON.parse(actions);
  }

  public maxRole(): Role {
    const user: any = this.getUser();
    let maxRole: Role = user.roles[0];
    let hiererchie = maxRole?.id;
    user?.roles.forEach(elt => {
      if (elt.hierarchie >= hiererchie) {
        hiererchie = elt.hierarchie;
        maxRole = elt;
      }
    });
    return maxRole;
  }

  public saveMode(data: any): void {
    window.sessionStorage.removeItem(MODE);
    window.sessionStorage.setItem(MODE, JSON.stringify(data));
  }
  public getMode(): any {
    return JSON.parse(sessionStorage.getItem(MODE));
  }

  public saveCodeSite(data: any): void {
    window.sessionStorage.removeItem(CODE_SITE);
    window.sessionStorage.setItem(CODE_SITE, JSON.stringify(data));
  }
  public getCodeSite(): any {
    return JSON.parse(sessionStorage.getItem(CODE_SITE));
  }

  public getRoleUserSociete(): any {
    const stored = sessionStorage.getItem(ACTIVER_UTILISATION_ROLE_ADMIN_SOCIETE);
    if (!stored) { return {valeur: '0'}; }
    return JSON.parse(stored);
  }

  public saveRoleUserSociete(roleUserSociete: any): void {
    console.log('RoleUserSociete', roleUserSociete);
    window.sessionStorage.removeItem(ACTIVER_UTILISATION_ROLE_ADMIN_SOCIETE);
    window.sessionStorage.setItem(ACTIVER_UTILISATION_ROLE_ADMIN_SOCIETE, JSON.stringify(roleUserSociete));
  }


}
